export default "__VITE_ASSET__DyP1Q6u9__"